import { defineStore } from 'pinia'
import request from '@/utils/request'
import type { Notification } from '@/types/notification'
import { NotificationStatus } from '@/types/notification'

export const useNotificationStore = defineStore('notification', {
  state: () => ({
    notifications: [] as Notification[],
    total: 0,
    pages: 0,
    current: 1,
    size: 10,
    unreadCount: 0
  }),
  actions: {
    async fetchNotifications(params = { pageNum: 1, pageSize: 10 }) {
      const res = await request.post('/notification/selectnotification', params)
      if (res.data.code === 200) {
        const data = res.data.data
        this.notifications = data.notifications
        this.total = data.total
        this.pages = data.pages
        this.current = data.current
        this.size = data.size
        // 统计未读数量
        this.unreadCount = (data.notifications || []).filter((n: Notification) => n.status === NotificationStatus.UNREAD).length
      }
    }
  }
}) 